module.exports = __webpack_public_path__ + "static/media/logo.b40072bc.png";